import React from 'react';
import classes from './Heading.module.scss'
import bg from '../../../media/background.svg'
import bg768 from '../../../media/background-768.svg'
import bg1100 from '../../../media/background-1100.svg'
import noise from '../../../media/noise.png'
import arrowIcon from '../../../media/icons/arrow-right-plain.svg'

export interface HeadingProps {
  title: string[],
  description: string[],
  buttonText?: string,
  maxWidth?: number,
  imageName?: string,
  imageHeight?: number
  imageWidth?: number
    href?:string
}

// todo use in all Services and Industries

const Heading = ({title, description, buttonText, maxWidth = 815, imageName, imageHeight = 400, imageWidth = 400, href}:HeadingProps) => {
  return (
      <section className={classes.container} id="nav-dark">
        <img alt="" className={classes.background} src={bg}/>
        <img alt="" className={classes['background-768']} src={bg768}/>
        <img alt="" className={classes['background-1100']} src={bg1100}/>
        <img alt="" className={classes.noise} src={noise}/>

        <div className={classes.content}
        >
            <div className={classes.text} style={{ maxWidth: `${maxWidth}px` }}>
              <h1>{title[0]} <span className={classes.gradient}>{title[1]}</span></h1>
              {description.map((text, i) => <p key={i}>{text}</p>)}
              {!!buttonText && !!href && <button onClick={() => window.open(href, "_blank")}><span>{buttonText}</span><img alt="" src={arrowIcon}/></button>}
            </div>

            {!!imageName && <img className={classes.avatar} style={{height: `${imageHeight}px`, width: `${imageWidth}px`}}
                  src={require(`../media/${imageName}`)} alt={title[0]}/>}
        </div>
      </section>
  );
};

export default Heading;